import {
    computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { navigate } from 'gatsby';
import { PAGE_SIZE, UserInfo, VmList } from '../constants/options';
import { SetLocalStorage } from '../utilities/cryptography';
import { get } from 'http';

export default class SettingStore {

    loading: boolean = false;
    loadingInfo: boolean = false;
    updating: boolean = false;
    deleting: boolean = false;


    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        makeObservable(this, {
            loading: observable,
            loadingInfo: observable,
            updating: observable,
            deleting: observable,
        });
        this.rootStore = rootStore;
    }
// Academic Year APIs
    createAcademicYear = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/AcademicYear`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    getAllAcademicYears = async () => {
        this.loading = true;
        try {
            const res = await Axios.get(`/api/AcademicYear`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    deleteAcademicYear = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/AcademicYear/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };

    updateAcademicYear = async (id: string, model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/AcademicYear/${id}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };
// Plan APIs
    createPlan = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Plan`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    getAllPlans = async (model: any, skip: number, take: number) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Plan/Search/${skip}/${take}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    deletePlan = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/Plan/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };

    getPlanById = async (id: string) => {
        this.loadingInfo = true;
        try {
            const res = await Axios.get(`/api/Plan/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loadingInfo = false;
        }
    };

    updatePlan = async (id: string, model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/Plan/${id}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };
// Grade APIs
    createGrade = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Grade`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    getAllGrades = async (model: any, skip: number, take: number) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Grade/Search/${skip}/${take}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    updateGradeById = async (id: string, model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/Grade/Update-grade`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };

    deleteGradeById = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/Grade/Delete-grade`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };
// Knowledge Point APIs
    getAllKnowledgePoints = async () => {
        this.loading = true;
        try {
            const res = await Axios.get(`/api/KnowledgePoint/All-KnowledgePoints`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    deleteKnowledgePointById = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/KnowledgePoint/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };

    updateKnowledgePointById = async (id: string, model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/KnowledgePoint/${id}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };

    createKnowledgePoint = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/KnowledgePoint`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    getKnowledgePointById = async (id: string) => {
        this.loadingInfo = true;
        try {
            const res = await Axios.get(`/api/KnowledgePoint/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loadingInfo = false;
        }
    };

// Category APIs
    searchCategories = async (model: any, skip: number, take: number) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Category/Search/${skip}/${take}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    updateCategory = async (model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/Category`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };

    createCategory = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Category`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    deleteCategory = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/Category/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };

    getCategoryById = async (id: string) => {
        this.loadingInfo = true;
        try {
            const res = await Axios.get(`/api/Category/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loadingInfo = false;
        }
    };

// Criteria APIs
    searchCriterias = async (model: any, skip: number, take: number) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Criteria/Search/${skip}/${take}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    updateCriteria = async (model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/Criteria`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };

    createCriteria = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Criteria`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    deleteCriteria = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/Criteria/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };

    getCriteriaById = async (id: string) => {
        this.loadingInfo = true;
        try {
            const res = await Axios.get(`/api/Criteria/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loadingInfo = false;
        }
    };
}
